// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"bcb1fd65","44":"ed6d9f19","93":"1ca9c575","178":"ed6d9f19","265":"bcb1fd65","324":"a565e3fe","912":"1ca9c575","925":"a565e3fe"}[chunkId] + ".chunk.css";
};